export default "__VITE_ASSET__DAarKJj7__"